import BasicDrawer from './Basic';
import BottomButton from './BottomButton';
import Contents from './Contents';
import Header from './Header';

export const Basic = Object.assign(BasicDrawer, { BottomButton, Contents, Header });
